<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    {{_.startCase(reportName)}} - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    {{reportName}}
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row" :key="componentKey">
                <div class="col">
                    <pos-activity-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'pos_activity_reports'"></pos-activity-report>
                    <price-change-by-line-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile == 'price_change_by_line_reports'"></price-change-by-line-report>
                    <price-override-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile == 'price_override_reports'"></price-override-report>
                    <product-pricing-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile == 'product_pricing_reports'"></product-pricing-report>
                    <eod-by-cashier-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile == 'eod_by_cashier_and_pos'"></eod-by-cashier-report>
                    <adjustment-with-cost-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" :friendlyCode="friendlyCode" v-else-if="currentProfile == 'adjustment_out_journal_with_costs' || currentProfile=='adjustment_in_journal_with_costs'"></adjustment-with-cost-report>
                    <pos-operations-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile=='pos_sales_journals' || currentProfile=='pos_reservations_journals' || currentProfile=='pos_returns_journals'" :friendlyCode="friendlyCode"></pos-operations-report>
                    <stock-transfer-out-discrepancy-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile=='stock_transfer_out_discrepancy_reports'" :friendlyCode="friendlyCode"></stock-transfer-out-discrepancy-report>
                    <NonMovingItemsReport :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else-if="currentProfile == 'non_moving_items_reports'"></NonMovingItemsReport>
                    <AdjustmentOutReport :access_right="accessRights" :access_costprice_rights="accessCostPriceRights" :friendlyCode="friendlyCode" v-else-if="currentProfile == 'adjustment_out_journals'"></AdjustmentOutReport>
                    <forfeited-amount-report :access_right="accessRights" v-else-if="currentProfile == 'forfeited_amount_reports'"></forfeited-amount-report>
                    <operations-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-else :friendlyCode="friendlyCode"></operations-report>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    // import ReceivingReportJournal from '../Basic Operations Reports/ReceivingReportJournal';
    import OperationsReport from '../Basic Operations Reports/OperationsReport';
    import PosOperationsReport from '../Basic Operations Reports/PosOperationsReport';
    import PosActivityReport from '../Basic Operations Reports/PosActivityReport';
    import PriceChangeByLineReport from '../Basic Operations Reports/PriceChangeByLineReport';
    import PriceOverrideReport from '../Basic Operations Reports/PriceOverrideReport';
    import ProductPricingReport from '../Basic Operations Reports/ProductPricingReport';
    import EodByCashierReport from '../Basic Operations Reports/EodByCashierReport';
    import AdjustmentWithCostReport from '../Basic Operations Reports/AdjustmentWithCostReport';
    import StockTransferOutDiscrepancyReport from '../Basic Operations Reports/StockTransferOutDiscrepancyReport';
    import AdjustmentOutReport from './AdjustmentOutReport.vue';
    import NonMovingItemsReport from './NonMovingItemsReport.vue';
    import ForfeitedAmountReport from './ForfeitedAmountReport.vue';
    
    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                imagepath: secureStorage.getItem("account_logo"),
                reportName: 'Basic Operations Reports',
                activeModules: [],
                accessRights: [],
                accessCostPriceRights: [],
                componentKey: 0,
                friendlyCode: '',
                transOptions: [
                    {key: "", value: "pos_activity_reports"},
                    {key: "OVR", value: "price_change_by_line_reports"},
                    {key: "STODR", value: "stock_transfer_out_discrepancy_reports"},
                    {key: "EOD", value: "eod_by_cashier_and_pos"},
                    {key: "ORIPOX", value: "purchase_order_journals"},
                    {key: "RECDEL", value: "receiving_report_journals"},
                    {key: "ORITRQ", value: "transfer_request_journals"},
                    {key: "OROTRQ", value: "transfer_order_journals"},
                    {key: "RELTRX", value: "transfer_out_journals"},
                    {key: "RECTRX", value: "transfer_in_journals"},
                    {key: "OTHPUR", value: "purchase_request_journals"},
                    {key: "RELRSR", value: "purchase_return_journals"},
                    {key: "RECADJ", value: "adjustment_in_journals"},
                    {key: "RECADJ", value: "adjustment_in_journal_with_costs"},
                    {key: "RELADJ", value: "adjustment_out_journals"},
                    {key: "RELADJ", value: "adjustment_out_journal_with_costs"},
                    {key: "OTHPCN", value: "physical_count_journals"},
                    {key: "OTHASM", value: "assemble_journals"},
                    {key: "OTHDSM", value: "disassemble_journals"},
                    {key: "OTHCPO", value: "consolidated_po_journals"},
                    {key: "OTHBIN", value: "branch_inventory_journals"},
                    {key: "OTHQUO", value: "quotation_journals"},
                    {key: "OTHPWS", value: "price_work_sheet_journals"},
                    {key: "RELCSI", value: "concession_sales_journals"},
                    {key: "RECCSI", value: "concession_returns_journals"},
                    {key: "RELPOS", value: "pos_sales_journals"},
                    {key: "OROPOS", value: "pos_reservations_journals"},
                    {key: "RECPOS", value: "pos_returns_journals"},
                    {key: "RELSLO", value: "sublocation_transfer_out_journals"},
                    {key: "RECSLI", value: "sublocation_transfer_in_journals"},
                    {key: "ORISOX", value: "sales_order_journals"},
                    {key: "OTHSIN", value: "sales_invoice_journals"},
                    {key: "RELDDE", value: "delivery_document_journals"},
                    {key: "OTHSBI", value: "suppliers_bill_journals"},
                    {key: "ORIASN", value: "advance_shipment_notice_journals"},
                    {key: "ORICSQ", value: "concession_transfer_request_journals"},
                    {key: "OROCSQ", value: "concession_transfer_order_journals"},
                    {key: "RELCSX", value: "concession_transfer_out_journals"},
                    {key: "RECCSX", value: "concession_transfer_in_journals"},
                    {key: "", value: "forfeited_amount_reports"},
                ],
            }
        },
        mounted: async function () {
            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF
            this.updateBasicOperationReportOptions()
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            OperationsReport,
            PosActivityReport,
            PriceChangeByLineReport,
            PriceOverrideReport,
            ProductPricingReport,
            EodByCashierReport,
            PosOperationsReport,
            AdjustmentWithCostReport,
            StockTransferOutDiscrepancyReport,
            NonMovingItemsReport,
            AdjustmentOutReport,
            ForfeitedAmountReport
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }

                var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
                if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                    this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
                }else {
                    this.accessCostPriceRights = []
                }

                this.updateCurrentProfile(profile);
                this.friendlyCode = this.transOptions.find(x => x.value == this.currentProfile).key
                this.componentKey+=1;
            },
            
            async updateBasicOperationReportOptions(){
                this.activeModules = []
                let code = this.$route.params.code
                var component_x = this;

                var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=' + code + '&status=A', null, null)
                if(categoryId[0] != undefined){
                    this.reportName = categoryId[0].name
                    component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules?account_smcs_id=' + categoryId[0].account_smcs_id, null, null)
                    if (component_x.activeModules.length > 0) {
                        var profile = _.snakeCase(component_x.activeModules[0].name)
                        component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
                    } else {
                        component_x.setCurrentProfile(null, null);
                    }
                }

                this.componentKey+= 1;
            }
        },

        watch: {
            "$route.params.code"(to, from){
                if(to !== from){
                    this.updateBasicOperationReportOptions()
                }
            }
        }

    };
</script>

<style></style>